import type { ImmerStateCreator } from 'hooks/useStore';

export interface TicketingThreadSlice {
  renameTicketThreadId: string | null;
  selectedTicketThreadName: string | null;
  setRenameTicketThreadId: (id: string | null) => void;
  setSelectedTicketThreadName: (name: string | null) => void;
}

export const useTicketingThreadSlice: ImmerStateCreator<
  TicketingThreadSlice
> = (set) => ({
  renameTicketThreadId: null,
  selectedTicketThreadName: null,
  setRenameTicketThreadId: (id: string | null) =>
    set(
      (state) => {
        state.ticketingThreadSlice.renameTicketThreadId = id;
      },
      false,
      'setRenameTicketThreadId'
    ),
  setSelectedTicketThreadName: (name: string | null) =>
    set(
      (state) => {
        state.ticketingThreadSlice.selectedTicketThreadName = name;
      },
      false,
      'setSelectedTicketThreadName'
    ),
});
